import { motion } from "framer-motion";

const STEPS = [
  ["01", "Scegli i servizi", "Seleziona dal menu tutto ciò che ti serve, civile o industriale."],
  ["02", "Inviaci la richiesta", "Compila il modulo o mandaci la lista su WhatsApp in un tocco."],
  ["03", "Ricevi il preventivo", "Ti ricontattiamo per capire spazi e frequenza e prepariamo una proposta chiara."],
  ["04", "Si parte", "Concordiamo giorni e orari e iniziamo a pulire."],
];

export const Steps = () => (
  <section id="come-funziona" className="relative border-t border-white/10 bg-[#05080F] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <p className="eyebrow">Come funziona</p>
          <h2 className="mt-5 max-w-xl font-display text-4xl font-bold leading-[1] tracking-tight text-white sm:text-5xl">Dal menu allo spazio pulito, in quattro passi.</h2>
        </div>
      </div>
      <div className="mt-16 grid gap-px overflow-hidden rounded-[28px] border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map(([n, t, d], i) => (
          <motion.div
            key={n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group relative bg-[#070B14] p-8 transition-colors duration-500 hover:bg-[#0B1222]"
            data-testid={`step-${n}`}
          >
            <span className="font-display text-7xl font-extrabold text-stroke transition-colors duration-500 group-hover:text-[var(--cyan)]">{n}</span>
            <h3 className="mt-10 font-display text-xl font-semibold text-white">{t}</h3>
            <p className="mt-3 text-sm text-slate-400">{d}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
